import React, { Component } from "react";
import PropTypes from "prop-types";
import Loader from "../generic/Loading";
import logo from "../images/logo.svg";
import Input from "../generic/Input";
import { Link } from "react-router-dom";
import { requestAPI } from "../data/api";

class ForgotPasswordScreen extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: "",
      password: "",
      loading: false,
      emailSent: false,
      errors: []
    };
  }

  remindPassword = async () => {
    this.setState({
      loading: true
    });

    const res = await requestAPI("/authentication/forgot-password", "POST", {
      email: this.state.email
    });

    if (res.status === "error") {
      this.setState({ errors: res.errors });
    } else if (res.status === "success") {
      this.setState({ emailSent: true });
    }
    this.setState({
      loading: false
    });
  };

  gotoLogin = () => {
    this.props.history.push("/");
  };

  render() {
    return (
      <div id="welcome-content">
        <div
          style={{
            opacity: this.state.loading ? 1 : 0,
            transform: this.state.loading
              ? "translateY(0px)"
              : "translateY(50px)"
          }}
          className="loading"
        >
          <Loader />
        </div>
        <div
          style={{
            opacity: this.state.loading ? 0 : 1,
            transform: this.state.loading
              ? "translateY(-50px)"
              : "translateY(0px)"
          }}
          className="auth-box"
        >
          <img src={logo} className="logo" alt="logo" />
          <div className={!this.state.emailSent ? "hidden" : ""}>
            <h1 className="info-text">
              {this.context.gettext(
                "forgotPassword.screen.info_email_sent_text"
              )}
            </h1>
            <br />
            <br />
            <div style={{ display: "flex" }}>
              <a className="auth-link" onClick={this.remindPassword}>
                {this.context.gettext("forgotPassword.screen.resend_button")}
              </a>
              <button
                className="btn full-width auth-btn"
                onClick={this.gotoLogin}
              >
                {this.context.gettext(
                  "forgotPassword.screen.goto_login_button"
                )}
              </button>
            </div>
          </div>
          <div className={this.state.emailSent ? "hidden" : ""}>
            <h1 className="info-text">
              {this.context.gettext("forgotPassword.screen.info_text")}
            </h1>
            {this.state.errors.map(error => (
              <div className="warning">{error}</div>
            ))}
            <Input
              onKeyDown={e => {
                if (e.key === "Enter") this.remindPassword();
              }}
              onChange={e => {
                this.setState({
                  email: e.target.value
                });
              }}
              className="inp"
              type="text"
              value={this.state.email}
              placeholder={this.context.gettext(
                "forgotPassword.screen.placeholder.email"
              )}
            />
            <div className="d-flex has-spacing">
              <Link to={"/"} className="auth-link">
                {this.context.gettext("forgotPassword.screen.return_button")}
              </Link>
              <button
                className="btn full-width auth-btn"
                onClick={this.remindPassword}
                disabled={!this.state.email || this.state.loading}
              >
                {this.context.gettext("forgotPassword.screen.reset_button")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ForgotPasswordScreen.contextTypes = {
  gettext: PropTypes.func.isRequired,
};

export default ForgotPasswordScreen;
